import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { timeAgo } from "@/lib/format";
import { useProfileViewer } from "@/components/Layout";
import { ExpandableText } from "@/components/ExpandableText";

function AnswerItem({ r }) {
  const { viewProfile } = useProfileViewer();
  const navigate = useNavigate();
  return (
    <li data-testid={`my-answer-${r.id}`} className="py-5" style={{ borderBottom: "1px solid var(--border)" }}>
      <p className="long-text-sm text-sm italic mb-3 line-clamp-3" style={{ color: "var(--text-muted)" }}>“{r.inquiry_text}”</p>
      <ExpandableText text={r.text} testid={`my-answer-text-${r.id}`} className="text-base leading-relaxed" style={{ color: "var(--text-primary)" }} />
      <div className="flex items-center gap-3 mt-3 flex-wrap">
        <button onClick={() => viewProfile(r.asker?.id)} data-testid={`my-answer-asker-${r.id}`} className="text-xs opacity-70 hover:opacity-100 transition-opacity" style={{ color: "var(--text-secondary)" }}>
          to {r.asker?.name || "unknown"} · {timeAgo(r.created_at)}
        </button>
        {r.conversation_id ? (
          <button onClick={() => navigate(`/chat?c=${r.conversation_id}`)} data-testid={`my-answer-open-chat-${r.id}`} className="btn ml-auto text-xs tracking-widest px-3 py-1">OPEN CHAT →</button>
        ) : (
          <span className="ml-auto text-xs" style={{ color: "var(--text-muted)" }} data-testid={`my-answer-awaiting-${r.id}`}>awaiting reply</span>
        )}
      </div>
    </li>
  );
}

function MyAnswersModal({ onClose }) {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/responses/mine").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 fade-in" style={{ background: "rgba(0,0,0,0.75)" }} onClick={onClose} data-testid="my-answers-overlay">
      <div className="w-full max-w-xl p-8 max-h-[85vh] overflow-y-auto" style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }} onClick={(e) => e.stopPropagation()} data-testid="my-answers-modal">
        <div className="flex justify-between items-start mb-4">
          <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>my answers</span>
          <button onClick={onClose} data-testid="my-answers-close" className="text-sm opacity-60 hover:opacity-100" style={{ color: "var(--text-primary)" }}>[ close ]</button>
        </div>
        {items === null ? (
          <p className="text-sm" style={{ color: "var(--text-muted)" }}>Loading…</p>
        ) : items.length === 0 ? (
          <p className="text-sm" style={{ color: "var(--text-muted)" }} data-testid="my-answers-empty">You haven't answered anything yet.</p>
        ) : (
          <ul>{items.map((r) => <AnswerItem key={r.id} r={r} />)}</ul>
        )}
      </div>
    </div>
  );
}

export function MyAnswersButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="my-answers-btn" className="btn shrink-0 h-[46px] px-4 text-xs tracking-widest">MY ANSWERS</button>
      {open && createPortal(<MyAnswersModal onClose={() => setOpen(false)} />, document.body)}
    </>
  );
}
